import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { creditApplicationSelectors } from '../../data/store/CreditApplicationStore'
import { useAppSelector } from '../../data/store'

function FailedToObtainCreditReportForm() {
  const { id } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const creditApplication = useAppSelector(creditApplicationSelectors.getFilteredCreditApplication)

  React.useEffect(() => {
    if (creditApplication == null) {
      navigate(`/creditApplication/${id as string}`)
    }
  }, [creditApplication])

  function onSubmit(event: { preventDefault: () => void }) {
    navigate(`/creditApplication/${id}/income-verification`, { replace: true })
    event.preventDefault()
  }

  return (
    <main className="general-message">
      <form onSubmit={onSubmit}>
        <h4 className="subtitle">{t<string>('common.financeApplication')}</h4>
        <h1>{t('identity.cannotConfirm')}</h1>
        <div className="paragraph">
          <p>
            <Trans i18nKey="identity.hereToHelp" />
          </p>
          <p>{t('identity.notifyEmail')}</p>
          <p>{t('identity.consent')}</p>
          <div className="control-group">
            <input
              required
              type="checkbox"
              id="acceptConditions"
              onChange={(e) => {
                if (e.currentTarget.checked === true) e.currentTarget.setCustomValidity('')
              }}
              onInvalid={(e) => e.currentTarget.setCustomValidity(t<string>('common.acceptConditions'))}
            />
            <label htmlFor="acceptConditions">{t('identity.byClicking')}</label>
          </div>
        </div>
        <button type="submit" className="btn btn-blue" disabled={false}>
          <span>{t('common.submit')}</span>
          <i className="fa-regular fa-arrow-right" />
        </button>
      </form>
    </main>
  )
}

export default FailedToObtainCreditReportForm
